<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
    <div class="bg-white bg-opacity-10 backdrop-blur-xl p-8 rounded-2xl w-full max-w-md border border-white border-opacity-20 shadow-2xl transform transition-all duration-300 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-yellow-300 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      
      <h3 class="text-xl font-bold text-white mb-4">Nueva Entrevista</h3>
      <p class="mb-6 text-white text-opacity-90">¿Desea iniciar una nueva entrevista? Perderá el progreso actual.</p>
      
      <div class="flex justify-center space-x-4">
        <button @click="$emit('confirm')"
            class="bg-gradient-to-r from-yellow-400 to-yellow-500 text-blue-900 font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 hover:-translate-y-1 shadow-md">
          Sí, iniciar nueva
        </button>
        
        <button @click="$emit('cancel')"
            class="bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 hover:shadow-lg transform hover:scale-105 hover:-translate-y-1 shadow-md border border-white border-opacity-20">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
emits:['confirm', 'cancel']
};
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.backdrop-blur-xl {
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.hover\:scale-105:hover {
  transform: scale(1.05);
}

.hover\:-translate-y-1:hover {
  transform: translateY(-4px);
}
</style>